module.exports = __webpack_public_path__ + "static/media/cup_top_3.66c73610.png";